/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

export const selectAuthState = createSelector(
  (state: RootState) => state.auth,
  (authState) => authState
);
